import { useOutletContext } from 'react-router-dom'
import { type Supervisor } from 'service/api'

export function useSupervisoresOutletContext() {
    return useOutletContext<{
        data: Supervisor[]
    }>()
}
